export function t(key, context) {
  const message = (window.__MESSAGES__ || {})[key];
  if (!message) {
    // eslint-disable-next-line
    console.log('Missing message for key:', key);
    return key;
  }
  if (context) {
    return message.replace(/\{([^}]+)\}/g, (match, p1) => escape(context[p1]));
  } else {
    return message;
  }
}

// not sure about other chars, first get "<>" in.
/* eslint-disable */
const entityMap = {
  // '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
  // '"': '&quot;',
  // "'": '&#39;',
  // '/': '&#x2F;',
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    //return data.replace(/[&<>"'\/]/g, s => entityMap[s]);
    return data.replace(/[<>]/g, s => entityMap[s]);
  }

  return data === undefined ? '' : data;
}
